const FIXED_INCOME_REQUEST_KYC_FIELDS = `
  id
  title
  surname
  firstName
  otherNames
  gender
  maritalStatus
  dateOfBirth
  placeOfBirth
  mothersMaidenName
  residentialStatus
  countryOfOrigin
  countryOfResidence
  residentialAddress
  digitalAddress
  mobileNumber
  emailAddress
  residentPermitNumber
  placeOfIssue
  permitIssueDate
  permitExpiryDate
  passportUrl
  residentRegion
  residentCity
  residentPermitStatus
  employmentStatus
  nameOfEmployerSchool
  addressOfEmployerSchool
  cityTown
  natureOfBusiness
  businessSchoolOfficeContactNumber
  businessSchoolOfficeEmail
  yearsOfEmployment
  yearsOfCurrentEmployment
  yearsOfPreviousEmployment
  occupation
  taxIdentificationNumber
  profession
  professionalLicenseNumber
  payoutCurrency
  payoutAccountName
  payoutAccountNumber
  payoutBankName
  payoutBankBranchName
  payoutPaymentMethod
  beneficiaries {
    id
    beneficiaryType
    beneficiaryTitle
    beneficiaryFullName
    beneficiaryGender
    beneficiaryMaritalStatus
    beneficiaryRelationship
    beneficiaryDateOfBirth
    beneficiaryPlaceOfBirth
    beneficiaryResidentialStatus
    beneficiaryCountryOfOrigin
    beneficiaryCountryOfResidence
    beneficiaryResidentialAddress
    beneficiaryPercentageOfBenefit
    beneficiaryDigitalAddress
    beneficiaryOccupation
    beneficiaryTaxIdentificationNumber
    beneficiaryMobileNumber1
    beneficiaryMobileNumber2
    beneficiaryGhanaCardUrl
    beneficiaryPassportUrl
  }
  sourceOfFunds
  expectedDepositAmount
  expectedWithdrawalAmount
  expectedFrequencyOfDeposit
  expectedFrequencyOfWithdrawal
  communicationMethod
  isCitizenOfForeignCountry
  holdsPassportOfForeignCountry
  holdsGreenCardOfForeignCountry
  isResidentInForeignCountry
  spentMoreThan183DaysInForeignCountry
  foreignFullName
  foreignResidentialAddress
  foreignMailingAddress
  foreignTelephoneNumber
  foreignTinSsnNationalId
  approximateAnnualIncome
  investmentCurrency
  investmentHorizon
  objectives
  investmentKnowledge
  riskTolerance
  modeOfStatementDelivery
  statementFrequency
  statementFrequencyOther
  hasBoughtSecuritiesBefore
  existingCsdClientId
  clientType
  accountOrigination
  pepStatus
  verifiedByCsdOfficer
  csdOfficerSignatureUrl
  csdVerificationDate
  csdStampUrl
  clientCsdSecuritiesAccountNumbers
  createdAt
  updatedAt
  riskProfile {
    finalScore
    riskLevel
    factorsEvaluated
    totalPossibleFactors
    details
    missingDetails
    computedAt
  }
  kycDeclaration
  kycDocuments
`;

export const GET_FIXED_INCOME_REQUEST = `
  query GetFixedIncomeRequest($id: ID!) {
    fixedIncomeRequest(id: $id) {
      id
      createdAt
      updatedAt
      state
      source
      issuedDate
      sourceRedemption {
        id
        amount
        interestEarned
        penalty
        redemptionType
        redemptionTiming
        reference
        state
        rollOver
        fixedIncomeRequest{
          id
        }
        assignedTo {
          id
          name
        }
        rolledOverFixedIncomeRequest {
          id
        }
        createdAt
        updatedAt
      }
      assignedTo {
        name
      }
      maturityDate
      maturesIn
      redeemableAmount
      daysInvested
      allocationBreakdown
      fixedIncomePaymentInstruction {
        id
        state
        amountsPaid
        totalAmountPaid
        assignedTo {
          id
          name
        }
        rate
        tenure
        isin
        receiptUrl
        settlementDate
        transactionType
        createdAt
        updatedAt
      }
      fixedIncomeRedemptions {
        id
        amount
        interestEarned
        penalty
        redemptionType
        redemptionTiming
        reference
        state
        canTransitionToNextStates
        allocationBreakdown
        metaData
        fixedIncomeRequestId
        createdAt
        updatedAt
        accountName
        accountNumber
        bankName
        paymentMethod
        rolledOverFixedIncomeRequest {
          id
        }
        rollOver
        assignedTo{
          id
          name
        }
      }
      product{
        id
        name
        fundCode
        fixedIncomeOffers {
          product {
            id
            name
          }
          id
          rate
          minAmount
          maxAmount
          isActive
          tenure
        }
      }
      canTransitionToNextStates
      fixedIncomeRequestNotes {
        id
        note {
          id
          description
          createdAt
          updatedAt
          user {
            id
            name
          }
        }
      }
      fixedIncomePayments {
        id
        paymentReceiptUrl
        amount
        state
        paymentDate
        paymentMethod
        accountName
        accountNumber
        reference
        createdAt
        updatedAt
      }
      fixedIncomeRequestStateReasons {
        id
        fixedIncomeRequestReasonId
        fixedIncomeRequestReason {
          id
          status
          description
        }
        comment
        isActive
        createdAt
        updatedAt
      }
      fixedIncomeRequestKyc {
        ${FIXED_INCOME_REQUEST_KYC_FIELDS}
      }
      customer {
        id
        firstName
        middleName
        lastName
        idIssueDate
        idExpiryDate
        lastFixedIncomeRequestKyc {
          ${FIXED_INCOME_REQUEST_KYC_FIELDS}
        }
        ghanaCardIdUrl
        ghanaCardIdBackUrl
        ghanaCardNo
        gender
        dateOfBirth
        petraId
        activeCustomerPhones {
          id
          phone {
            id
            number
            type
          }
          isPrimary
          isActive
        }
        customerAddresses {
          id
          address {
            id
            streetName
            ghPost
            poBox
            region
            city
            isPostalBox
            country {
              id
              name
            }
          }
          isPrimary
          isActive
        }
        customerEmails {
          id
          email {
            id
            address
          }
          isPrimary
          isActive
        }
        employers {
          id
          name
          industrySector {
            name
          }
          petraId
          tinNumber
        }
      }
      customerSubscription {
        id
        brokerageProductId
      }
      provider {
        id
        name
      }
      product {
        id
        name
      }
    }
  }
`;

export const GET_FIXED_INCOME_REQUESTS = `
  query GetFixedIncomeRequests($page: ID, $perPage: ID) {
    fixedIncomeRequests(page: $page, perPage: $perPage) {
      count
      results {
        id
        createdAt
        updatedAt
        state
        source
        customer {
          id
          firstName
          lastName
          petraId
        }
        provider {
          id
          name
        }
        product {
          id
          name
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const CREATE_FIXED_INCOME_REQUEST = `
  mutation CreateFixedIncomeRequest(
    $customerId: ID
    $providerId: ID!
    $productId: ID!
    $assignedToId: ID!
    $source: String!
    $newCustomer: Boolean
    $firstName: String
    $gender: String
    $lastName: String
    $middleName: String
    $dateOfBirth: String
    $ghanaCardNo: String
    $phoneNumbers: [String!]
    $emails: [String!]
  ) {
    createFixedIncomeRequest(
      customerId: $customerId
      providerId: $providerId
      productId: $productId
      assignedToId: $assignedToId
      source: $source
      newCustomer: $newCustomer
      firstName: $firstName
      gender: $gender
      lastName: $lastName
      middleName: $middleName
      dateOfBirth: $dateOfBirth
      ghanaCardNo: $ghanaCardNo
      phoneNumbers: $phoneNumbers
      emails: $emails
    ) {
      fixedIncomeRequest {
        id
        state
        customer {
          id
          firstName
          lastName
          petraId
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const UPDATE_FIXED_INCOME_REQUEST = `
  mutation UpdateFixedIncomeRequest(
    $id: ID!
    $customerId: ID
    $providerId: ID
    $productId: ID
    $assignedToId: ID!
    $source: String
    $issuedDate: String
  ) {
    updateFixedIncomeRequest(
      id: $id
      customerId: $customerId
      providerId: $providerId
      productId: $productId
      assignedToId: $assignedToId
      source: $source
      issuedDate: $issuedDate
    ) {
      fixedIncomeRequest {
        id
        state
        customer {
          id
          fullname
        }
        provider {
          id
          name
        }
        product {
          id
          name
        }
        assignedTo {
          id
          name
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const GET_FIXED_INCOME_REQUEST_LOGS = `
  query GetFixedIncomeRequestLogs($fixedIncomeRequestId: ID!) {
    fixedIncomeRequestChangeLogs(fixedIncomeRequestId: $fixedIncomeRequestId) {
      audits {
        auditItem
        createdAt
        action
        newValue
        oldValue
        user
        comment
      }
      stateAudits {
        auditItem
        createdAt
        action
        newValue
        oldValue
        user
        comment
      }
    }
  }
`;

export const ASSIGN_ATTACHMENT_TO_FIXED_INCOME_REQUEST = `
  mutation AssignAttachmentsToFixedIncomeRequest($attachmentIds: [ID!]!, $fixedIncomeRequestId: ID!) {
    assignAttachmentsToFixedIncomeRequest(attachmentIds: $attachmentIds, fixedIncomeRequestId: $fixedIncomeRequestId) {
      fixedIncomeRequest {
        fixedIncomeRequestAttachments {
          id
          attachment {
            id
            url
            name
            createdAt
          }
        }
      }
    }
  }
`;

export const UNASSIGN_ATTACHMENT_FROM_FIXED_INCOME_REQUEST = `
  mutation UnassignAttachmentFromFixedIncomeRequest($id: ID!) {
    unassignAttachmentFromFixedIncomeRequest(id: $id) {
      result
      errors {
        description
        property
      }
    }
  }
`;

export const GET_FIXED_INCOME_REQUEST_FOR_EDIT = `
  query GetFixedIncomeRequestForEdit($id: ID!) {
    fixedIncomeRequest(id: $id) {
      id
      state
      customer {
        id
        fullname
        petraId
      }
      provider {
        id
        name
      }
      product {
        id
        name
      }
      assignedTo {
        id
        name
      }
      issuedDate
    }
  }
`;

export const GET_FIXED_INCOME_REQUEST_NOTIFIER_RECORDS_QUERY = `
  query GetFixedIncomeRequest($fixedIncomeRequestId: ID!) {
    fixedIncomeRequest(id: $fixedIncomeRequestId) {
      notifierRecords {
        id
        notificationType
        status
        message
        recipient
        reference
        createdAt
        updatedAt
        customer {
          id
          petraId
        }
      }
    }
  }
`;

export const CREATE_FIXED_INCOME_REQUEST_KYC = `
  mutation CreateFixedIncomeRequestKyc(
    $fixedIncomeRequestId: ID
    $customerId: ID!
    $title: String
    $surname: String
    $firstName: String
    $otherNames: String
    $gender: String
    $maritalStatus: String
    $dateOfBirth: String
    $placeOfBirth: String
    $mothersMaidenName: String
    $residentialStatus: String
    $countryOfOrigin: String
    $countryOfResidence: String
    $residentialAddress: String
    $digitalAddress: String
    $mobileNumber: String
    $emailAddress: String
    $residentPermitNumber: String
    $placeOfIssue: String
    $permitIssueDate: String
    $permitExpiryDate: String
    $residentRegion: String
    $residentCity: String
    $residentPermitStatus: String
    $employmentStatus: String
    $nameOfEmployerSchool: String
    $addressOfEmployerSchool: String
    $cityTown: String
    $natureOfBusiness: String
    $businessSchoolOfficeContactNumber: String
    $businessSchoolOfficeEmail: String
    $yearsOfEmployment: Int
    $yearsOfCurrentEmployment: Int
    $yearsOfPreviousEmployment: Int
    $occupation: String
    $taxIdentificationNumber: String
    $profession: String
    $professionalLicenseNumber: String
    $payoutCurrency: String
    $payoutAccountName: String
    $payoutAccountNumber: String
    $payoutBankName: String
    $payoutBankBranchName: String
    $payoutPaymentMethod: String
    $beneficiaries: [BeneficiaryInput!]
    $sourceOfFunds: String
    $expectedDepositAmount: String
    $expectedWithdrawalAmount: String
    $expectedFrequencyOfDeposit: String
    $expectedFrequencyOfWithdrawal: String
    $isCitizenOfForeignCountry: Boolean
    $holdsPassportOfForeignCountry: Boolean
    $holdsGreenCardOfForeignCountry: Boolean
    $isResidentInForeignCountry: Boolean
    $spentMoreThan183DaysInForeignCountry: Boolean
    $foreignFullName: String
    $foreignResidentialAddress: String
    $foreignMailingAddress: String
    $foreignTelephoneNumber: String
    $foreignTinSsnNationalId: String
    $approximateAnnualIncome: String
    $investmentCurrency: String
    $investmentHorizon: String
    $objectives: String
    $investmentKnowledge: String
    $riskTolerance: String
    $modeOfStatementDelivery: [String!]
    $statementFrequency: String
    $statementFrequencyOther: String
    $hasBoughtSecuritiesBefore: Boolean
    $existingCsdClientId: String
    $clientType: String
    $accountOrigination: String
    $pepStatus: String
    $verifiedByCsdOfficer: String
    $csdOfficerSignatureUrl: String
    $csdVerificationDate: String
    $csdStampUrl: String
    $clientCsdSecuritiesAccountNumbers: String
    $communicationMethod: [String!]
    $kycDeclaration: String
    $kycDocuments: [String!]
    $passportUrl: String
  ) {
    createFixedIncomeRequestKyc(
      customerId: $customerId
      fixedIncomeRequestId: $fixedIncomeRequestId
      title: $title
      surname: $surname
      firstName: $firstName
      otherNames: $otherNames
      gender: $gender
      maritalStatus: $maritalStatus
      dateOfBirth: $dateOfBirth
      placeOfBirth: $placeOfBirth
      mothersMaidenName: $mothersMaidenName
      residentialStatus: $residentialStatus
      countryOfOrigin: $countryOfOrigin
      countryOfResidence: $countryOfResidence
      residentialAddress: $residentialAddress
      digitalAddress: $digitalAddress
      mobileNumber: $mobileNumber
      emailAddress: $emailAddress
      residentPermitNumber: $residentPermitNumber
      placeOfIssue: $placeOfIssue
      permitIssueDate: $permitIssueDate
      permitExpiryDate: $permitExpiryDate
      residentRegion: $residentRegion
      residentCity: $residentCity
      residentPermitStatus: $residentPermitStatus
      employmentStatus: $employmentStatus
      nameOfEmployerSchool: $nameOfEmployerSchool
      addressOfEmployerSchool: $addressOfEmployerSchool
      cityTown: $cityTown
      natureOfBusiness: $natureOfBusiness
      businessSchoolOfficeContactNumber: $businessSchoolOfficeContactNumber
      businessSchoolOfficeEmail: $businessSchoolOfficeEmail
      yearsOfEmployment: $yearsOfEmployment
      yearsOfCurrentEmployment: $yearsOfCurrentEmployment
      yearsOfPreviousEmployment: $yearsOfPreviousEmployment
      occupation: $occupation
      taxIdentificationNumber: $taxIdentificationNumber
      profession: $profession
      professionalLicenseNumber: $professionalLicenseNumber
      payoutCurrency: $payoutCurrency
      payoutAccountName: $payoutAccountName
      payoutAccountNumber: $payoutAccountNumber
      payoutBankName: $payoutBankName
      payoutBankBranchName: $payoutBankBranchName
      payoutPaymentMethod: $payoutPaymentMethod
      beneficiaries: $beneficiaries
      sourceOfFunds: $sourceOfFunds
      expectedDepositAmount: $expectedDepositAmount
      expectedWithdrawalAmount: $expectedWithdrawalAmount
      expectedFrequencyOfDeposit: $expectedFrequencyOfDeposit
      expectedFrequencyOfWithdrawal: $expectedFrequencyOfWithdrawal
      isCitizenOfForeignCountry: $isCitizenOfForeignCountry
      holdsPassportOfForeignCountry: $holdsPassportOfForeignCountry
      holdsGreenCardOfForeignCountry: $holdsGreenCardOfForeignCountry
      isResidentInForeignCountry: $isResidentInForeignCountry
      spentMoreThan183DaysInForeignCountry: $spentMoreThan183DaysInForeignCountry
      foreignFullName: $foreignFullName
      foreignResidentialAddress: $foreignResidentialAddress
      foreignMailingAddress: $foreignMailingAddress
      foreignTelephoneNumber: $foreignTelephoneNumber
      foreignTinSsnNationalId: $foreignTinSsnNationalId
      approximateAnnualIncome: $approximateAnnualIncome
      investmentCurrency: $investmentCurrency
      investmentHorizon: $investmentHorizon
      objectives: $objectives
      investmentKnowledge: $investmentKnowledge
      riskTolerance: $riskTolerance
      modeOfStatementDelivery: $modeOfStatementDelivery
      statementFrequency: $statementFrequency
      statementFrequencyOther: $statementFrequencyOther
      hasBoughtSecuritiesBefore: $hasBoughtSecuritiesBefore
      existingCsdClientId: $existingCsdClientId
      clientType: $clientType
      accountOrigination: $accountOrigination
      pepStatus: $pepStatus
      verifiedByCsdOfficer: $verifiedByCsdOfficer
      csdOfficerSignatureUrl: $csdOfficerSignatureUrl
      csdVerificationDate: $csdVerificationDate
      csdStampUrl: $csdStampUrl
      clientCsdSecuritiesAccountNumbers: $clientCsdSecuritiesAccountNumbers
      communicationMethod: $communicationMethod
      kycDeclaration: $kycDeclaration
      kycDocuments: $kycDocuments
      passportUrl: $passportUrl
    ) {
      fixedIncomeRequestKyc {
        ${FIXED_INCOME_REQUEST_KYC_FIELDS}
      }
      errors {
        property
        description
      }
    }
  }
`;

export const UPDATE_FIXED_INCOME_REQUEST_KYC = `
  mutation UpdateFixedIncomeRequestKyc(
    $id: ID!
    $fixedIncomeRequestId: ID
    $customerId: ID
    $title: String
    $surname: String
    $firstName: String
    $otherNames: String
    $gender: String
    $maritalStatus: String
    $dateOfBirth: String
    $placeOfBirth: String
    $mothersMaidenName: String
    $residentialStatus: String
    $countryOfOrigin: String
    $countryOfResidence: String
    $residentialAddress: String
    $digitalAddress: String
    $mobileNumber: String
    $emailAddress: String
    $residentPermitNumber: String
    $placeOfIssue: String
    $permitIssueDate: String
    $permitExpiryDate: String
    $residentRegion: String
    $residentCity: String
    $residentPermitStatus: String
    $employmentStatus: String
    $nameOfEmployerSchool: String
    $addressOfEmployerSchool: String
    $cityTown: String
    $natureOfBusiness: String
    $businessSchoolOfficeContactNumber: String
    $businessSchoolOfficeEmail: String
    $yearsOfEmployment: Int
    $yearsOfCurrentEmployment: Int
    $yearsOfPreviousEmployment: Int
    $occupation: String
    $taxIdentificationNumber: String
    $profession: String
    $professionalLicenseNumber: String
    $payoutCurrency: String
    $payoutAccountName: String
    $payoutAccountNumber: String
    $payoutBankName: String
    $payoutBankBranchName: String
    $payoutPaymentMethod: String
    $beneficiaries: [BeneficiaryInput!]
    $sourceOfFunds: String
    $expectedDepositAmount: String
    $expectedWithdrawalAmount: String
    $expectedFrequencyOfDeposit: String
    $expectedFrequencyOfWithdrawal: String
    $isCitizenOfForeignCountry: Boolean
    $holdsPassportOfForeignCountry: Boolean
    $holdsGreenCardOfForeignCountry: Boolean
    $isResidentInForeignCountry: Boolean
    $spentMoreThan183DaysInForeignCountry: Boolean
    $foreignFullName: String
    $foreignResidentialAddress: String
    $foreignMailingAddress: String
    $foreignTelephoneNumber: String
    $foreignTinSsnNationalId: String
    $approximateAnnualIncome: String
    $investmentCurrency: String
    $investmentHorizon: String
    $objectives: String
    $investmentKnowledge: String
    $riskTolerance: String
    $modeOfStatementDelivery: [String!]
    $statementFrequency: String
    $statementFrequencyOther: String
    $hasBoughtSecuritiesBefore: Boolean
    $existingCsdClientId: String
    $clientType: String
    $accountOrigination: String
    $pepStatus: String
    $verifiedByCsdOfficer: String
    $csdOfficerSignatureUrl: String
    $csdVerificationDate: String
    $csdStampUrl: String
    $clientCsdSecuritiesAccountNumbers: String
    $communicationMethod: [String!]
    $kycDeclaration: String
    $kycDocuments: [String!]
    $passportUrl: String
  ) {
    updateFixedIncomeRequestKyc(
      id: $id
      customerId: $customerId
      fixedIncomeRequestId: $fixedIncomeRequestId
      title: $title
      surname: $surname
      firstName: $firstName
      otherNames: $otherNames
      gender: $gender
      maritalStatus: $maritalStatus
      dateOfBirth: $dateOfBirth
      placeOfBirth: $placeOfBirth
      mothersMaidenName: $mothersMaidenName
      residentialStatus: $residentialStatus
      countryOfOrigin: $countryOfOrigin
      countryOfResidence: $countryOfResidence
      residentialAddress: $residentialAddress
      digitalAddress: $digitalAddress
      mobileNumber: $mobileNumber
      emailAddress: $emailAddress
      residentPermitNumber: $residentPermitNumber
      placeOfIssue: $placeOfIssue
      permitIssueDate: $permitIssueDate
      permitExpiryDate: $permitExpiryDate
      residentRegion: $residentRegion
      residentCity: $residentCity
      residentPermitStatus: $residentPermitStatus
      employmentStatus: $employmentStatus
      nameOfEmployerSchool: $nameOfEmployerSchool
      addressOfEmployerSchool: $addressOfEmployerSchool
      cityTown: $cityTown
      natureOfBusiness: $natureOfBusiness
      businessSchoolOfficeContactNumber: $businessSchoolOfficeContactNumber
      businessSchoolOfficeEmail: $businessSchoolOfficeEmail
      yearsOfEmployment: $yearsOfEmployment
      yearsOfCurrentEmployment: $yearsOfCurrentEmployment
      yearsOfPreviousEmployment: $yearsOfPreviousEmployment
      occupation: $occupation
      taxIdentificationNumber: $taxIdentificationNumber
      profession: $profession
      professionalLicenseNumber: $professionalLicenseNumber
      payoutCurrency: $payoutCurrency
      payoutAccountName: $payoutAccountName
      payoutAccountNumber: $payoutAccountNumber
      payoutBankName: $payoutBankName
      payoutBankBranchName: $payoutBankBranchName
      payoutPaymentMethod: $payoutPaymentMethod
      beneficiaries: $beneficiaries
      sourceOfFunds: $sourceOfFunds
      expectedDepositAmount: $expectedDepositAmount
      expectedWithdrawalAmount: $expectedWithdrawalAmount
      expectedFrequencyOfDeposit: $expectedFrequencyOfDeposit
      expectedFrequencyOfWithdrawal: $expectedFrequencyOfWithdrawal
      isCitizenOfForeignCountry: $isCitizenOfForeignCountry
      holdsPassportOfForeignCountry: $holdsPassportOfForeignCountry
      holdsGreenCardOfForeignCountry: $holdsGreenCardOfForeignCountry
      isResidentInForeignCountry: $isResidentInForeignCountry
      spentMoreThan183DaysInForeignCountry: $spentMoreThan183DaysInForeignCountry
      foreignFullName: $foreignFullName
      foreignResidentialAddress: $foreignResidentialAddress
      foreignMailingAddress: $foreignMailingAddress
      foreignTelephoneNumber: $foreignTelephoneNumber
      foreignTinSsnNationalId: $foreignTinSsnNationalId
      approximateAnnualIncome: $approximateAnnualIncome
      investmentCurrency: $investmentCurrency
      investmentHorizon: $investmentHorizon
      objectives: $objectives
      investmentKnowledge: $investmentKnowledge
      riskTolerance: $riskTolerance
      modeOfStatementDelivery: $modeOfStatementDelivery
      statementFrequency: $statementFrequency
      statementFrequencyOther: $statementFrequencyOther
      hasBoughtSecuritiesBefore: $hasBoughtSecuritiesBefore
      existingCsdClientId: $existingCsdClientId
      clientType: $clientType
      accountOrigination: $accountOrigination
      pepStatus: $pepStatus
      verifiedByCsdOfficer: $verifiedByCsdOfficer
      csdOfficerSignatureUrl: $csdOfficerSignatureUrl
      csdVerificationDate: $csdVerificationDate
      csdStampUrl: $csdStampUrl
      clientCsdSecuritiesAccountNumbers: $clientCsdSecuritiesAccountNumbers
      communicationMethod: $communicationMethod
      kycDeclaration: $kycDeclaration
      kycDocuments: $kycDocuments
      passportUrl: $passportUrl
    ) {
      fixedIncomeRequestKyc {
        ${FIXED_INCOME_REQUEST_KYC_FIELDS}
      }
      errors {
        property
        description
      }
    }
  }
`;

export const GET_FIXED_INCOME_REQUEST_KYC = `
  query GetFixedIncomeRequestKyc($id: ID!) {
    fixedIncomeRequestKyc(id: $id) {
      ${FIXED_INCOME_REQUEST_KYC_FIELDS}
      customer {
        id
        firstName
        middleName
        lastName
        dateOfBirth
        gender
        ghanaCardNo
        ghanaCardIdUrl
        ghanaCardIdBackUrl
      }
    }
  }
`;

export const CREATE_FIXED_INCOME_REQUEST_NOTE_TICKET = `
mutation CreateFixedIncomeRequestNoteTicket($source: String!, $properties: JSON!, $fixedIncomeRequestNoteId: String!, $ticketSubCategoryId: ID) {
  createFixedIncomeRequestNoteTicket(source: $source, properties: $properties, fixedIncomeRequestNoteId: $fixedIncomeRequestNoteId, ticketSubCategoryId: $ticketSubCategoryId){
    ticket {
      id
      properties
      reference
      source
      url
    }
    errors {
      property
      description
    }
  }
}
`;

export const ASSIGN_NOTE_TO_FIXED_INCOME_REQUEST = `
mutation AssignNoteToFixedIncomeRequest($noteId: ID!, $fixedIncomeRequestId: ID!) {
  assignNoteToFixedIncomeRequest(noteId: $noteId, fixedIncomeRequestId: $fixedIncomeRequestId){
    fixedIncomeRequestNote {
      id
      note {
        id
        description
        createdAt
        updatedAt
      }
      fixedIncomeRequest {
        id
      }
      isActive
      createdAt
      updatedAt
    }
    errors {
      property
      description
    }
  }
}
`;

export const UNASSIGN_NOTE_FROM_FIXED_INCOME_REQUEST = `
mutation UnassignNoteFromFixedIncomeRequest($id: ID!) {
  unassignNoteFromFixedIncomeRequest(id: $id){
    result
    errors {
      property
      description
    }
  }
}
`;

export const MOVE_FIXED_INCOME_REQUEST_TO_STATE = `
  mutation MoveFixedIncomeRequestToState(
    $fixedIncomeRequestId: ID!
    $comment: String!
    $state: String!
    $event: String!
    $issuedDate: ISO8601Date
    $isin: String
    $fixedIncomeRequestReasonId: ID
  ) {
    moveFixedIncomeRequestToState(
      fixedIncomeRequestId: $fixedIncomeRequestId
      comment: $comment
      state: $state
      event: $event
      issuedDate: $issuedDate
      isin: $isin
      fixedIncomeRequestReasonId: $fixedIncomeRequestReasonId
    ) {
      fixedIncomeRequest {
        id
        state
        createdAt
        updatedAt
      }
      errors {
        property
        description
      }
    }
  }
`;

export const CREATE_FIXED_INCOME_PAYMENT = `
  mutation CreateFixedIncomePayment(
    $amount: Float!
    $paymentDate: ISO8601Date!
    $paymentReceiptUrl: String
    $fixedIncomeRequestId: ID!
    $accountName: String
    $accountNumber: String
    $bankName: String
    $metaData: JSON
    $paymentMethod: String
  ) {
    createFixedIncomePayment(
      amount: $amount
      paymentDate: $paymentDate
      paymentReceiptUrl: $paymentReceiptUrl
      fixedIncomeRequestId: $fixedIncomeRequestId
      accountName: $accountName
      accountNumber: $accountNumber
      bankName: $bankName
      metaData: $metaData
      paymentMethod: $paymentMethod
    ) {
      fixedIncomePayment {
        id
        amount
        paymentDate
        paymentReceiptUrl
        accountName
        paymentMethod
        accountNumber
        bankName
        metaData
        state
      }
      errors {
        property
        description
      }
    }
  }
`;

export const CALCULATE_FIXED_INCOME_ALLOCATION_BREAKDOWN = `
  query CalculateFixedIncomeAllocationBreakdown(
    $id: ID!
    $amount: Float
    $rediscountDate: ISO8601Date
    $redemptionType: String
    $serviceCostRate: Float
  ) {
    calculateFixedIncomeAllocationBreakdown(
      id: $id
      amount: $amount
      rediscountDate: $rediscountDate
      redemptionType: $redemptionType
      serviceCostRate: $serviceCostRate
    )
  }
`;

export const CREATE_FIXED_INCOME_REDEMPTION = `
  mutation CreateFixedIncomeRedemption(
    $amount: Float!
    $fixedIncomeRequestId: ID!
    $rediscountDate: ISO8601Date
    $accountName: String!
    $accountNumber: String!
    $bankName: String!
    $paymentMethod: String!
    $rollOver: Boolean
    $assignedToId: ID
    $supportingDocumentUrl: String
    $redemptionType: String
    $serviceCostRate: Float
  ) {
    createFixedIncomeRedemption(
      amount: $amount
      fixedIncomeRequestId: $fixedIncomeRequestId
      rediscountDate: $rediscountDate
      accountName: $accountName
      accountNumber: $accountNumber
      bankName: $bankName
      paymentMethod: $paymentMethod
      rollOver: $rollOver
      assignedToId: $assignedToId
      supportingDocumentUrl: $supportingDocumentUrl
      redemptionType: $redemptionType
      serviceCostRate: $serviceCostRate
    ) {
      fixedIncomeRedemption {
        id
        amount
        interestEarned
        penalty
        redemptionType
        redemptionTiming
        state
        allocationBreakdown
        accountName
        accountNumber
        bankName
        paymentMethod
        rollOver
        assignedTo {
          id
          name
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const MOVE_FIXED_INCOME_REDEMPTION_TO_STATE = `
  mutation MoveFixedIncomeRedemptionToState(
    $fixedIncomeRedemptionId: ID!
    $state: String!
    $event: String!
    $comment: String
    $fixedIncomeRequestReasonId: ID
  ) {
    moveFixedIncomeRedemptionToState(
      fixedIncomeRedemptionId: $fixedIncomeRedemptionId
      state: $state
      event: $event
      comment: $comment
      fixedIncomeRequestReasonId: $fixedIncomeRequestReasonId
    ) {
      fixedIncomeRedemption {
        id
        amount
        interestEarned
        penalty
        redemptionType
        redemptionTiming
        state
        reference
        allocationBreakdown
        accountName
        accountNumber
        bankName
        paymentMethod
        canTransitionToNextStates
        createdAt
        updatedAt
        rollOver
        assignedTo{
          id
          name
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const SEARCH_FIXED_INCOME_REQUESTS = `
  query SearchFixedIncomeRequests(
    $q: String
    $page: ID!
    $numberPerPage: ID
    $filters: FixedIncomeRequestFilterInput
    $orderBy: FixedIncomeRequestOrderByInput
  ) {
    fixedIncomeRequests(
      q: $q
      page: $page
      numberPerPage: $numberPerPage
      filters: $filters
      orderBy: $orderBy
    ) {
      count
      results {
        id
        createdAt
        updatedAt
        state
        source
        customer {
          id
          firstName
          lastName
          petraId
        }
        provider {
          id
          name
        }
        product {
          id
          name
        }
        assignedTo {
          id
          name
          email
        }
      }
    }
  }
`;

export const GET_FIXED_INCOME_REQUEST_REASONS = `
  query GetFixedIncomeRequestReasons($state: String!) {
    fixedIncomeRequestReasons(state: $state) {
      id
      status
      description
    }
  }
`;

export const GET_KYC_ENUM_OPTIONS = `
  query GetKycEnumOptions {
    kycEnumOptions
  }
`;

export const CREATE_FIXED_INCOME_PAYMENT_INSTRUCTION = `
  mutation CreateFixedIncomePaymentInstruction(
    $fixedIncomeRequestId: ID!
    $assignedToId: ID!
    $amountsPaid: [Float!]!
    $rate: Float!
    $tenure: Int!
    $receiptUrl: String
    $transactionType: String
  ) {
    createFixedIncomePaymentInstruction(
      fixedIncomeRequestId: $fixedIncomeRequestId
      assignedToId: $assignedToId
      amountsPaid: $amountsPaid
      rate: $rate
      tenure: $tenure
      receiptUrl: $receiptUrl
      transactionType: $transactionType
    ) {
      fixedIncomePaymentInstruction {
        id
        state
        totalAmountPaid
        amountsPaid
        rate
        tenure
        receiptUrl
        isin
        transactionType
        assignedTo {
          id
          name
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const UPDATE_FIXED_INCOME_PAYMENT_INSTRUCTION = `
  mutation UpdateFixedIncomePaymentInstruction(
    $id: ID!
    $assignedToId: ID
    $amountsPaid: [Float!]
    $rate: Float
    $tenure: Int
    $receiptUrl: String
    $transactionType: String
  ) {
    updateFixedIncomePaymentInstruction(
      id: $id
      assignedToId: $assignedToId
      amountsPaid: $amountsPaid
      rate: $rate
      tenure: $tenure
      receiptUrl: $receiptUrl
      transactionType: $transactionType
    ) {
      fixedIncomePaymentInstruction {
        id
        state
        amountsPaid
        totalAmountPaid
        rate
        tenure
        receiptUrl
        transactionType
        assignedTo {
          id
          name
        }
        createdAt
        updatedAt
      }
      errors {
        property
        description
      }
    }
  }
`;

export const GET_FIXED_INCOME_REDEMPTION = `
  query GetFixedIncomeRedemption($id: ID!) {
    fixedIncomeRedemption(id: $id) {
      id
      amount
      interestEarned
      penalty
      redemptionType
      redemptionTiming
      supportingDocumentUrl
      reference
      state
      allocationBreakdown
      metaData
      fixedIncomeRequestId
      createdAt
      updatedAt
      accountName
      accountNumber
      bankName
      totalRedemptionAmount
      paymentMethod
      rollOver
      serviceCost
      csdCharge
      remainingBalance
      remainingTenor
      fixedIncomeRequest {
        id
        product {
          id
          fundCode
        }
      }
      canTransitionToNextStates
      rolledOverFixedIncomeRequest {
        id
      }
      assignedTo {
        id
        name
      }
      notifierRecords {
        id
        notificationType
        status
        message
        recipient
        reference
        createdAt
        updatedAt
        customer {
          id
          petraId
        }
      }
    }
  }
`;

export const GET_FIXED_INCOME_REDEMPTION_STATE_ENUM = `
  {
    __type(name: "FixedIncomeRedemptionStateEnum") {
      enumValues {
        name
        description
      }
    }
  }
`;

export const GET_FIXED_INCOME_REDEMPTION_SORT_FIELDS = `
  {
    __type(name: "FixedIncomeRedemptionSortFieldEnum") {
      enumValues {
        name
        description
      }
    }
  }
`;

export const SEARCH_FIXED_INCOME_REDEMPTIONS = `
  query SearchFixedIncomeRedemptions(
    $page: ID!
    $q: String
    $numberPerPage: ID
    $filters: FixedIncomeRedemptionFilterInput
    $orderBy: FixedIncomeRedemptionOrderByInput
  ) {
    fixedIncomeRedemptions(
      page: $page
      q: $q
      numberPerPage: $numberPerPage
      filters: $filters
      orderBy: $orderBy
    ) {
      count
      results {
        id
        amount
        state
        createdAt
        updatedAt
        fixedIncomeRequest{
          customer {
            id
            firstName
            lastName
            petraId
          }
          product {
            id
            name
          }
          provider {
            id
            name
          }
        }
        assignedTo {
          id
          name
        }
      }
    }
  }
`;

export const GET_FIXED_INCOME_PAYMENT_INSTRUCTION_STATE_ENUM = `
  {
    __type(name: "FixedIncomePaymentInstructionStateEnum") {
      enumValues {
        name
        description
      }
    }
  }
`;

export const GET_FIXED_INCOME_PAYMENT_INSTRUCTION_SORT_FIELDS = `
  {
    __type(name: "FixedIncomePaymentInstructionSortFieldEnum") {
      enumValues {
        name
        description
      }
    }
  }
`;

export const SEARCH_FIXED_INCOME_PAYMENT_INSTRUCTIONS = `
  query SearchFixedIncomePaymentInstructions(
    $page: ID!
    $q: String
    $numberPerPage: ID
    $filters: FixedIncomePaymentInstructionFilterInput
    $orderBy: FixedIncomePaymentInstructionOrderByInput
  ) {
    fixedIncomePaymentInstructions(
      page: $page
      q: $q
      numberPerPage: $numberPerPage
      filters: $filters
      orderBy: $orderBy
    ) {
      count
      results {
        id
        totalAmountPaid
        state
        createdAt
        updatedAt
        fixedIncomeRequest {
          id
          customer {
            id
            firstName
            lastName
            petraId
          }
          product {
            id
            name
          }
          provider {
            id
            name
          }
        }
        assignedTo {
          id
          name
        }
      }
    }
  }
`;

export const GET_FIXED_INCOME_PAYMENT_INSTRUCTION = `
  query GetFixedIncomePaymentInstruction($id: ID!) {
    fixedIncomePaymentInstruction(id: $id) {
      id
      totalAmountPaid
      state
      rate
      tenure
      amountsPaid
      createdAt
      updatedAt
      receiptUrl
      fixedIncomeRequest{
        id
        customer {
          id
          firstName
          lastName
          petraId
        }
        provider {
          id
          name
        }
        product{
          id
          name
          fixedIncomeOffers {
            product {
              id
              name
            }
            id
            rate
            minAmount
            maxAmount
            isActive
            tenure
          }
        }
      }
      assignedTo {
        id
        name
        email
      }
    }
  }
`;

export const GET_FIXED_INCOME_REQUEST_STATE_ENUM = `
  query GetFixedIncomeRequestStateEnum {
    __type(name: "FixedIncomeRequestStateEnum") {
      name
      enumValues {
        name
        description
      }
    }
  }
`;

export const GET_FIXED_INCOME_REQUEST_SORT_FIELDS = `
  query GetFixedIncomeRequestSortFields {
    __type(name: "FixedIncomeRequestSortFieldEnum") {
      name
      enumValues {
        name
        description
      }
    }
  }
`;
